module.exports = "<div class=\"notification\">\r\n    <div class=\"alert alert-{{ notification.status}} fade show\" role=\"alert\">\r\n      <div class=\"icon-wrap-sm notification-icon-wrap\">\r\n        <span class=\"icon-white icon-transparent\" ></span>\r\n      </div>\r\n      {{ notification.message }}\r\n      <a href=\"#\" class=\"notification-close\" (click)=\"clearNotification()\">\r\n        <span aria-hidden=\"true\">&times;</span>\r\n      </a>\r\n    </div>\r\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/notification/notification.component.html
// module id = ./src/app/shared/notification/notification.component.html
// module chunks = main